import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { ExpandLess, ExpandMore, Inventory } from "@mui/icons-material";

import { useGetThemeDataQuery } from "../../Services/vehicle/Vehicle";
import { GARAGE_ROLE, GARAGE_TOKEN } from "../../constants";
import axios from "axios";
import { isAutoServicesTenant } from "../../utils/tenantBranding";

const WorkshopDrawerContent = () => {
  const location = useLocation();

  const getId = location.pathname.split("/");
  console.log(getId[3], "getteteetee");

  const [workshopOpen, setWorkshopOpen] = useState(false);
  const [isVehicleOpen, setIsVehicleOpen] = useState(false);
  const [serviceOpen, setServiceOpen] = useState(false);
  const [appointmentOpen, setAppointmentOpen] = useState(false);
  const isWorkshopView = location.pathname.startsWith("/vehicle/workshop");

  const { data: themeData } = useGetThemeDataQuery({});

  const fetchingTenant = window.location.hostname.split(".")[0];
  const autoServicesBranding = isAutoServicesTenant(fetchingTenant);
  const apiPort = process.env.REACT_APP_API_PROTOCOL;
  const token = localStorage.getItem(GARAGE_TOKEN);

  const isAnyChildActive = (paths) => {
    return paths.some((path) => location.pathname.startsWith(path));
  };

  const themeColors = {
    blue: "#F25D21",
    purple: "#F25D21",
    pantone: "#F25D21", // adjust this to the actual Pantone color you want
    orange: "#F25D21",
  };

  const themeBackgroundColors = {
    blue: "#F8E9E3",
    purple: "#F8E9E3",
    pantone: "#F8E9E3", // adjust this to the actual Pantone color you want
    orange: "#F8E9E3",
  };

  const themeBorderColors = {
    blue: "#F25D21",
    purple: "#F25D21",
    pantone: "#F25D21", // adjust this to the actual Pantone color you want
    orange: "#F25D21",
  };

  const selectedColor = themeColors[themeData?.selected_theme] || "grey"; // fallback color
  const selectedBackgroundColor =
    themeBackgroundColors[themeData?.selected_theme] || "grey"; // fallback color
  const selectedBorderColor =
    themeBorderColors[themeData?.selected_theme] || "grey"; // fallback color

  // Common text style for all menu items
  const menuTextStyle = {
    fontFamily: "Karbon",
    fontSize: "14px",
    color: "#666",
  };

  const renderDotText = (text, path) => {
    const isActive = location.pathname === path;
    return (
      <span
        style={{
          color: isActive ? `${selectedColor}` : "grey",
          fontFamily: "Karbon",
          fontSize: "14px",
        }}
      >
        • <span style={{ color: "inherit" }}>{text}</span>
      </span>
    );
  };

  const isGarageAdminLoggedIn = localStorage.getItem(GARAGE_ROLE);

  const logoutAdmin = async () => {
    try {
      const response = await axios.post(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/user/logout/`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.data) {
        localStorage.removeItem(GARAGE_TOKEN);
        localStorage.removeItem(GARAGE_ROLE);

        // window.location.replace('/home');
        window.location.replace("/auth/admin-login");
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  const handleLogout = () => {
    logoutAdmin();
  };

  return (
    <List component="nav" style={{ paddingTop: "0px" }}>
      <div
        style={{
          height: "80px",
          width: "250px",
          overflow: "hidden",
          borderTopRightRadius: "50px",
          background: "#F25D213D",
          marginBottom: "20px",
        }}
      >
        <img
          src={
            autoServicesBranding
              ? "https://botgobucket.s3.ap-south-1.amazonaws.com/AutoServices/Logo+1.svg"
              : "https://botgobucket.s3.ap-south-1.amazonaws.com/ercs+images/europearelogo.png"
          }
          alt={autoServicesBranding ? "Auto Services logo" : "EUROREPAR logo"}
          style={{
            width: autoServicesBranding ? "200px" : "144px",
            height: "42px",
            objectFit: "contain",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            marginTop: "20px",
            marginLeft: autoServicesBranding ? "8%" : "15%",
          }}
        />
        {/* {themeData?.logo && (
                         <img
                             src={`http://stellantis.localhost:8000${themeData?.logo}`}
                             alt="Theme Logo"
                             style={{ width: "100%", height: "100%" }}
                         />
                     )} */}
      </div>

      {isGarageAdminLoggedIn === "garage_tenant_admin" ? (
        <>
          {/* Workshop start */}

          <ListItemButton
            onClick={() => setWorkshopOpen(!workshopOpen)}
            style={{
              marginBottom: "10px",
              boxShadow: isAnyChildActive([
                "/vehicle/workshop-onboard",
                "/vehicle/workshop-listed",
                `vehicle/workshop-listed/${getId[3]}`,
                `/vehicle/workshop-edit/${getId[3]}`,
              ])
                ? `${selectedColor}80 0px 2px 10px 2px`
                : "",
              color: isAnyChildActive([
                "/vehicle/workshop-onboard",
                "/vehicle/workshop-listed",
                `vehicle/workshop-listed/${getId[3]}`,
                `/vehicle/workshop-edit/${getId[3]}`,
              ])
                ? `${selectedColor}`
                : "",
              borderRadius: isAnyChildActive([
                "/vehicle/workshop-onboard",
                "/vehicle/workshop-listed",
                `/vehicle/workshop-listed/${getId[3]}`,
                `/vehicle/workshop-edit/${getId[3]}`,
              ])
                ? "40px"
                : "",
              marginLeft: "20px",
              marginRight: "20px",
              border: isAnyChildActive([
                "/vehicle/workshop-onboard",
                "/vehicle/workshop-listed",
                `/vehicle/workshop-listed/${getId[3]}`,
                `/vehicle/workshop-edit/${getId[3]}`,
              ])
                ? `1px solid ${selectedColor}`
                : "",
              backgroundColor: isAnyChildActive([
                "/vehicle/workshop-onboard",
                "/vehicle/workshop-listed",
                `/vehicle/workshop-listed/${getId[3]}`,
                `/vehicle/workshop-edit/${getId[3]}`,
              ])
                ? `${selectedBackgroundColor}`
                : "transparent",
            }}
          >
            <ListItemIcon style={{ minWidth: "35px" }}>
              {/* <Inventory style={{color : isAnyChildActive(["/vehicle/service-type", "/vehicle/sub_service-type"]) ? `${selectedColor}` : ""}}/> */}
              <i
                className="bi bi-car-front"
                style={{
                  color: isAnyChildActive([
                    "/vehicle/workshop-onboard",
                    "/vehicle/workshop-listed",
                    `/vehicle/workshop-listed/${getId[3]}`,
                    `/vehicle/workshop-edit/${getId[3]}`,
                  ])
                    ? `${selectedColor}`
                    : "",
                  fontSize: "17px",
                }}
              ></i>
              {/* <img src="/Union.png" alt="Dashboard Icon"  style={{ width: 24, height: 24, color: isAnyChildActive(["/vehicle/service-type", "/vehicle/sub_service-type"]) ? `${selectedColor}` : "" }} /> */}
            </ListItemIcon>
            <ListItemText
              primary="Workshop"
              primaryTypographyProps={{ style: menuTextStyle }}
            />
            {serviceOpen ? (
              <ExpandLess
                style={{
                  color: isAnyChildActive([
                    "/vehicle/workshop-onboard",
                    "/vehicle/workshop-listed",
                    `vehicle/workshop-listed/${getId[3]}`,
                    `/vehicle/workshop-edit/${getId[3]}`,
                  ])
                    ? `${selectedColor}`
                    : "",
                }}
              />
            ) : (
              <ExpandMore />
            )}
          </ListItemButton>
          <Collapse in={workshopOpen} timeout="auto" unmountOnExit>
            <List
              component="div"
              disablePadding
              style={{ paddingLeft: "55px" }}
              sx={{ pl: 4 }}
            >
              <ListItemButton component={Link} to="/vehicle/workshop-onboard">
                <ListItemText
                  primary={renderDotText(
                    "Workshop onbaord",
                    "/vehicle/workshop-onboard"
                  )}
                />
              </ListItemButton>

              <ListItemButton component={Link} to="/vehicle/workshop-listed">
                <ListItemText
                  primary={renderDotText(
                    "Workshops Listed",
                    "/vehicle/workshop-listed"
                  )}
                />
              </ListItemButton>
            </List>
          </Collapse>
        </>
      ) : (
        ""
      )}

      {/* Worklshop end */}

      {/* Service */}

      <ListItemButton
        onClick={() => setServiceOpen(!serviceOpen)}
        style={{
          marginBottom: "10px",
          boxShadow: isAnyChildActive([
            "/vehicle/service-type",
            "/vehicle/sub_service-type",
          ])
            ? `${selectedColor}80 0px 2px 10px 2px`
            : "",
          color: isAnyChildActive([
            "/vehicle/service-type",
            "/vehicle/sub_service-type",
          ])
            ? `${selectedColor}`
            : "",
          borderRadius: isAnyChildActive([
            "/vehicle/service-type",
            "/vehicle/sub_service-type",
          ])
            ? "40px"
            : "",
          marginLeft: "20px",
          marginRight: "20px",
          border: isAnyChildActive([
            "/vehicle/service-type",
            "/vehicle/sub_service-type",
          ])
            ? `1px solid ${selectedColor}`
            : "",
          backgroundColor: isAnyChildActive([
            "/vehicle/service-type",
            "/vehicle/sub_service-type",
          ])
            ? `${selectedBackgroundColor}`
            : "transparent",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          {/* <Inventory style={{color : isAnyChildActive(["/vehicle/service-type", "/vehicle/sub_service-type"]) ? `${selectedColor}` : ""}}/> */}
          <i
            className="bi bi-journal-album"
            style={{
              color: isAnyChildActive([
                "/vehicle/service-type",
                "/vehicle/sub_service-type",
              ])
                ? `${selectedColor}`
                : "",
              fontSize: "17px",
            }}
          ></i>
          {/* <img src="/Union.png" alt="Dashboard Icon"  style={{ width: 24, height: 24, color: isAnyChildActive(["/vehicle/service-type", "/vehicle/sub_service-type"]) ? `${selectedColor}` : "" }} /> */}
        </ListItemIcon>
        <ListItemText
          primary="Service"
          primaryTypographyProps={{ style: menuTextStyle }}
        />
        {serviceOpen ? (
          <ExpandLess
            style={{
              color: isAnyChildActive([
                "/vehicle/service-type",
                "/vehicle/sub_service-type",
              ])
                ? `${selectedColor}`
                : "",
            }}
          />
        ) : (
          <ExpandMore />
        )}
      </ListItemButton>
      <Collapse in={serviceOpen} timeout="auto" unmountOnExit>
        <List
          component="div"
          disablePadding
          style={{ paddingLeft: "55px" }}
          sx={{ pl: 4 }}
        >
          {/* <ListItemButton component={Link} to="/vehicle/make">
                 <ListItemText primary={renderDotText("Make", "/vehicle/make")} />
               </ListItemButton> */}
          <ListItemButton component={Link} to="/vehicle/service-type">
            <ListItemText
              primary={renderDotText("Service", "/vehicle/service-type")}
            />
          </ListItemButton>
          <ListItemButton component={Link} to="/vehicle/sub_service-type">
            <ListItemText
              primary={renderDotText(
                "Sub Service Type",
                "/vehicle/sub_service-type"
              )}
            />
          </ListItemButton>
          {/* <ListItemButton component={Link} to="/vehicle/service">
                 <ListItemText  primary={renderDotText("Service", "/vehicle/service")}/>
               </ListItemButton> */}
        </List>
      </Collapse>

      {/* Service End */}

      {/* vehicle */}
      <ListItemButton
        onClick={() => setIsVehicleOpen(!isVehicleOpen)}
        style={{
          // marginBottom: "10px",
          boxShadow: isAnyChildActive([
            "/vehicle/make",
            "/vehicle/model",
            "/vehicle/fuel_type",
          ])
            ? `${selectedColor}80 0px 2px 10px 2px`
            : "",
          color: isAnyChildActive([
            "/vehicle/make",
            "/vehicle/model",
            "/vehicle/fuel_type",
          ])
            ? ` ${selectedColor}`
            : "",
          border: isAnyChildActive([
            "/vehicle/make",
            "/vehicle/model",
            "/vehicle/fuel_type",
          ])
            ? `1px solid ${selectedBorderColor}`
            : "",
          marginLeft: "20px",
          marginRight: "20px",
          borderRadius: "40px",
          backgroundColor: isAnyChildActive([
            "/vehicle/make",
            "/vehicle/model",
            "/vehicle/fuel_type",
          ])
            ? `${selectedBackgroundColor}`
            : "transparent",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <Inventory
            style={{
              color: isAnyChildActive([
                "/vehicle/make",
                "/vehicle/model",
                "/vehicle/fuel_type",
              ])
                ? `${selectedColor}`
                : "",
            }}
          />
          {/* <img src="/Vector.png" alt="Dashboard Icon"  style={{ width: 24, height: 24, color: isAnyChildActive(["/vehicle/make", "/vehicle/model", "/vehicle/fuel_type"]) ? `${selectedColor}` : "" }} /> */}
        </ListItemIcon>
        <ListItemText
          primary="Vehicle"
          primaryTypographyProps={{ style: menuTextStyle }}
        />
        {isVehicleOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={isVehicleOpen} timeout="auto" unmountOnExit>
        <List
          component="div"
          disablePadding
          style={{ paddingLeft: "55px" }}
          sx={{ pl: 4 }}
        >
          <ListItemButton component={Link} to="/vehicle/make">
            <ListItemText primary={renderDotText("Brand", "/vehicle/make")} />
          </ListItemButton>
          <ListItemButton component={Link} to="/vehicle/model">
            <ListItemText primary={renderDotText("Model", "/vehicle/model")} />
          </ListItemButton>
          <ListItemButton component={Link} to="/vehicle/fuel_type">
            <ListItemText
              primary={renderDotText("Fuel Type", "/vehicle/fuel_type")}
            />
          </ListItemButton>
          {/* <ListItemButton component={Link} to="/vehicle/service">
                 <ListItemText  primary={renderDotText("Service", "/vehicle/service")}/>
               </ListItemButton> */}
        </List>
      </Collapse>

      {/* Vehicle end */}

      <ListItemButton
        component={Link}
        to="/vehicle/consent"
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          //  marginBottom: "10px",
          boxShadow: isAnyChildActive(["/vehicle/consent"])
            ? `${selectedColor}80 0px 2px 10px 2px`
            : "",
          color: isAnyChildActive(["/vehicle/consent"])
            ? `${selectedColor}`
            : "",
          border: isAnyChildActive(["/vehicle/consent"])
            ? `1px solid ${selectedBorderColor}`
            : "",
          backgroundColor: isAnyChildActive(["/vehicle/consent"])
            ? `${selectedBackgroundColor}`
            : "transparent",
          borderRadius: "40px",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <i
            className="bi bi-bookmark-check-fill"
            style={{
              fontSize: "24px",
              color: isAnyChildActive(["/vehicle/consent"])
                ? `${selectedColor}`
                : "",
            }}
          ></i>
        </ListItemIcon>
        <ListItemText
          primary="Consent"
          primaryTypographyProps={{ style: menuTextStyle }}
        />
      </ListItemButton>

      <ListItemButton
        component={Link}
        to="/vehicle/banner"
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          //  marginBottom: "10px",
          boxShadow: isAnyChildActive(["/vehicle/banner"])
            ? `${selectedColor}80 0px 2px 10px 2px`
            : "",
          color: isAnyChildActive(["/vehicle/banner"])
            ? `${selectedColor}`
            : "",
          border: isAnyChildActive(["/vehicle/banner"])
            ? `1px solid ${selectedBorderColor}`
            : "",
          backgroundColor: isAnyChildActive(["/vehicle/banner"])
            ? `${selectedBackgroundColor}`
            : "transparent",
          borderRadius: "40px",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <i
            className="bi bi-layout-text-window"
            style={{
              fontSize: "24px",
              color: isAnyChildActive(["/vehicle/banner"])
                ? `${selectedColor}`
                : "",
            }}
          ></i>
        </ListItemIcon>
        <ListItemText
          primary="Banner"
          primaryTypographyProps={{ style: menuTextStyle }}
        />
      </ListItemButton>

      <ListItemButton
        component={Link}
        to="/vehicle/gallery"
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          boxShadow: isAnyChildActive(["/vehicle/gallery"])
            ? `${selectedColor}80 0px 2px 10px 2px`
            : "",
          color: isAnyChildActive(["/vehicle/gallery"])
            ? `${selectedColor}`
            : "",
          border: isAnyChildActive(["/vehicle/gallery"])
            ? `1px solid ${selectedBorderColor}`
            : "",
          backgroundColor: isAnyChildActive(["/vehicle/gallery"])
            ? `${selectedBackgroundColor}`
            : "transparent",
          borderRadius: "40px",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <i
            className="bi bi-images"
            style={{
              fontSize: "24px",
              color: isAnyChildActive(["/vehicle/gallery"])
                ? `${selectedColor}`
                : "",
            }}
          ></i>
        </ListItemIcon>
        <ListItemText
          primary="Gallery"
          primaryTypographyProps={{ style: menuTextStyle }}
        />
      </ListItemButton>

      {/* Feedback start */}

      <ListItemButton
        component={Link}
        to="/vehicle/feedback"
        style={{
          boxShadow: isAnyChildActive(["/vehicle/feedback"])
            ? `${selectedColor}80 0px 2px 10px 2px`
            : "",
          color: isAnyChildActive(["/vehicle/feedback"])
            ? `${selectedColor}`
            : "",
          border: isAnyChildActive(["/vehicle/feedback"])
            ? `1px solid ${selectedBorderColor}`
            : "",
          marginLeft: "20px",
          marginRight: "20px",
          backgroundColor: isAnyChildActive(["/vehicle/feedback"])
            ? `${selectedBackgroundColor}`
            : "transparent",
          borderRadius: "40px",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <i
            className="bi bi-chat-dots-fill"
            style={{
              fontSize: "24px",
              color: isAnyChildActive(["/vehicle/feedback"])
                ? `${selectedColor}`
                : "",
            }}
          ></i>
        </ListItemIcon>
        <ListItemText
          primary="Feedback"
          primaryTypographyProps={{ style: menuTextStyle }}
        />
      </ListItemButton>

      {/* Feedback end  */}

      {/* Configuraion start */}

      <ListItemButton
        component={Link}
        to="/vehicle/configuration"
        style={{
          boxShadow: isAnyChildActive(["/vehicle/configuration"])
            ? `${selectedColor}80 0px 2px 10px 2px`
            : "",
          color: isAnyChildActive(["/vehicle/configuration"])
            ? `${selectedColor}`
            : "",
          border: isAnyChildActive(["/vehicle/configuration"])
            ? `1px solid ${selectedBorderColor}`
            : "",
          marginLeft: "20px",
          marginRight: "20px",
          backgroundColor: isAnyChildActive(["/vehicle/configuration"])
            ? `${selectedBackgroundColor}`
            : "transparent",
          borderRadius: "40px",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <i
            className="bi bi-gear-wide-connected"
            style={{
              fontSize: "24px",
              color: isAnyChildActive(["/vehicle/configuration"])
                ? `${selectedColor}`
                : "",
            }}
          ></i>
          {/* <Dashboard
                             style={{
                                 minWidth: "35px",
                                 color: isAnyChildActive(["/vehicle/theme"])
                                     ? `${selectedColor}`
                                     : "",
                             }}
                         /> */}
        </ListItemIcon>
        <ListItemText
          primary="Configuration"
          primaryTypographyProps={{ style: menuTextStyle }}
        />
      </ListItemButton>

      {/* Appointment */}
      {/* <ListItemButton
        component={Link}
        to="/vehicle/appointment"
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          marginBottom: "10px",
          boxShadow: isAnyChildActive(["/vehicle/appointment"])
            ? `${selectedColor}80 0px 2px 10px 2px`
            : "",
          color: isAnyChildActive(["/vehicle/appointment"])
            ? `${selectedColor}`
            : "",
          border: isAnyChildActive(["/vehicle/appointment"])
            ? `1px solid ${selectedBorderColor}`
            : "",
          backgroundColor: isAnyChildActive(["/vehicle/appointment"])
            ? `${selectedBackgroundColor}`
            : "transparent",
          borderRadius: "40px",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <i
            className="bi bi-wrench-adjustable"
            style={{
              fontSize: "24px",
              color: isAnyChildActive(["/vehicle/appointment"])
                ? `${selectedColor}`
                : "",
            }}
          ></i>
        </ListItemIcon>
        <ListItemText
          primary="Appointment"
          primaryTypographyProps={{
            style: menuTextStyle,
          }}
        />
      </ListItemButton> */}
      <ListItemButton
        onClick={() => setAppointmentOpen(!appointmentOpen)}
        style={{
          marginBottom: "10px",
          boxShadow: isAnyChildActive([
            "/vehicle/appointment-pending",
            "/vehicle/appointment-confirmed",
          ])
            ? `${selectedColor}80 0px 2px 10px 2px`
            : "",
          color: isAnyChildActive([
            "/vehicle/appointment-pending",
            "/vehicle/appointment-confirmed",
          ])
            ? `${selectedColor}`
            : "",
          borderRadius: isAnyChildActive([
            "/vehicle/appointment-pending",
            "/vehicle/appointment-confirmed",
          ])
            ? "40px"
            : "",
          marginLeft: "20px",
          marginRight: "20px",
          border: isAnyChildActive([
            "/vehicle/appointment-pending",
            "/vehicle/appointment-confirmed",
          ])
            ? `1px solid ${selectedColor}`
            : "",
          backgroundColor: isAnyChildActive([
            "/vehicle/appointment-pending",
            "/vehicle/appointment-confirmed",
          ])
            ? `${selectedBackgroundColor}`
            : "transparent",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <i
            className="bi bi-wrench-adjustable"
            style={{
              color: isAnyChildActive([
                "/vehicle/appointment-pending",
                "/vehicle/appointment-confirmed",
              ])
                ? `${selectedColor}`
                : "",
              fontSize: "24px",
            }}
          ></i>
        </ListItemIcon>
        <ListItemText
          primary="Appointment"
          primaryTypographyProps={{ style: menuTextStyle }}
        />
        {appointmentOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={appointmentOpen} timeout="auto" unmountOnExit>
        <List
          component="div"
          disablePadding
          style={{ paddingLeft: "55px" }}
          sx={{ pl: 4 }}
        >
          <ListItemButton
            component={Link}
            to="/vehicle/appointment-pending"
            sx={{ pl: 4 }}
            style={{
              color: isAnyChildActive(["/vehicle/appointment-pending"])
                ? `${selectedColor}`
                : "inherit",
            }}
          >
            <ListItemText
              primary="Requested"
              primaryTypographyProps={{
                style: {
                  ...menuTextStyle,
                  fontSize: "0.9rem",
                  color: isAnyChildActive(["/vehicle/appointment-pending"])
                    ? `${selectedColor}`
                    : menuTextStyle.color,
                },
              }}
            />
          </ListItemButton>

          <ListItemButton
            component={Link}
            to="/vehicle/appointment-confirmed"
            sx={{ pl: 4 }}
            style={{
              color: isAnyChildActive(["/vehicle/appointment-confirmed"])
                ? `${selectedColor}`
                : "inherit",
            }}
          >
            <ListItemText
              primary="Confirmed"
              primaryTypographyProps={{
                style: {
                  ...menuTextStyle,
                  fontSize: "0.9rem",
                  color: isAnyChildActive(["/vehicle/appointment-confirmed"])
                    ? `${selectedColor}`
                    : menuTextStyle.color,
                },
              }}
            />
          </ListItemButton>
        </List>
      </Collapse>

      <ListItemButton
        component={Link}
        to="/vehicle/policy"
        style={{
          boxShadow: isAnyChildActive(["/vehicle/policy"])
            ? `${selectedColor}80 0px 2px 10px 2px`
            : "",
          color: isAnyChildActive(["/vehicle/policy"])
            ? `${selectedColor}`
            : "",
          border: isAnyChildActive(["/vehicle/policy"])
            ? `1px solid ${selectedBorderColor}`
            : "",
          marginLeft: "20px",
          marginRight: "20px",
          backgroundColor: isAnyChildActive(["/vehicle/policy"])
            ? `${selectedBackgroundColor}`
            : "transparent",
          borderRadius: "40px",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <i
            className="bi bi-file-earmark-text"
            style={{
              fontSize: "24px",
              color: isAnyChildActive(["/vehicle/policy"])
                ? `${selectedColor}`
                : "",
            }}
          ></i>
          {/* <Dashboard
                             style={{
                                 minWidth: "35px",
                                 color: isAnyChildActive(["/vehicle/theme"])
                                     ? `${selectedColor}`
                                     : "",
                             }}
                         /> */}
        </ListItemIcon>
        <ListItemText
          primary="Policy"
          primaryTypographyProps={{ style: menuTextStyle }}
        />
      </ListItemButton>

      <ListItemButton
        component={Link}
        to="/vehicle/faq"
        style={{
          boxShadow: isAnyChildActive(["/vehicle/faq"])
            ? `${selectedColor}80 0px 2px 10px 2px`
            : "",
          color: isAnyChildActive(["/vehicle/faq"]) ? `${selectedColor}` : "",
          border: isAnyChildActive(["/vehicle/faq"])
            ? `1px solid ${selectedBorderColor}`
            : "",
          marginLeft: "20px",
          marginRight: "20px",
          backgroundColor: isAnyChildActive(["/vehicle/faq"])
            ? `${selectedBackgroundColor}`
            : "transparent",
          borderRadius: "40px",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <i
            className="bi bi-question-circle"
            style={{
              fontSize: "24px",
              color: isAnyChildActive(["/vehicle/faq"])
                ? `${selectedColor}`
                : "",
            }}
          ></i>
        </ListItemIcon>
        <ListItemText
          primary="Faq"
          primaryTypographyProps={{ style: menuTextStyle }}
        />
      </ListItemButton>

      <ListItemButton
        component={Link}
        to="/vehicle/lead-generation"
        style={{
          boxShadow: isAnyChildActive(["/vehicle/lead-generation"])
            ? `${selectedColor}80 0px 2px 10px 2px`
            : "",
          color: isAnyChildActive(["/vehicle/lead-generation"])
            ? `${selectedColor}`
            : "",
          border: isAnyChildActive(["/vehicle/lead-generation"])
            ? `1px solid ${selectedBorderColor}`
            : "",
          marginLeft: "20px",
          marginRight: "20px",
          backgroundColor: isAnyChildActive(["/vehicle/lead-generation"])
            ? `${selectedBackgroundColor}`
            : "transparent",
          borderRadius: "40px",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <i
            className="bi bi-menu-up"
            style={{
              fontSize: "18px",
              color: isAnyChildActive(["/vehicle/lead-generation"])
                ? `${selectedColor}`
                : "",
            }}
          ></i>
        </ListItemIcon>
        <ListItemText
          primary="Leads"
          primaryTypographyProps={{ style: menuTextStyle }}
        />
      </ListItemButton>

      {/* Configuration end */}

      <ListItemButton
        onClick={handleLogout}
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          marginBottom: "10px",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <i className="bi bi-box-arrow-left" style={{ fontSize: "24px" }}></i>
        </ListItemIcon>
        <ListItemText
          primary="Logout"
          primaryTypographyProps={{ style: menuTextStyle }}
        />
      </ListItemButton>
    </List>
  );
};

export default WorkshopDrawerContent;
